export default {
  data: () => ({
    flag: false,
    userAccess: {},
    loadComponent: false,
  }),
  methods: {
    async isAuthorized(code, action) {
      return await this.$axios.get(
        `/api/userAccess/authorize/${code}/${action}`
      );
    },
    getUserAccessRights(trans) {
      this.$axios
        .get(`/api/userAccess/authorize/${trans}`)
        .then(({ data }) => {
          this.userAccess = data;
        })
        .catch(({ response }) => {
          this.toast.show(response.data);
        });
    },
  },
  watch: {
    userAccess(val) {
      if (val.view <= 0) {
        // console.log("access denied");
        this.$router.push("/401");
      } else {
        this.loadComponent = true;
      }
    },
  },
};
